import * as React from 'react';

import * as styles from './styles.css';

interface IContentWrapperProps {
  children: React.ReactNode;
}

export function ContentWrapper({ children }: IContentWrapperProps) {
  return <div className={styles['wrapper']}>{children}</div>;
}
